<template>
  <div>
    <el-button type="primary" class="print" :loading="btloading" @click="pageprint">
      打印
    </el-button>
    <!--<contract-agreement :contract-num="contractNum" v-if="contractNum" />-->
    <!--<iframe :src="framesrc" name="frame" class="printframe" />-->
    <div style="position: absolute;width:100%;height: 100%">
      <iframe src="http://fileservicetest.ruijie.com.cn/api/file/get/open/ecp/14322033055305728?Token=eyJhbGciOiJIUzI1NiJ9.eyJGU0NsYWltIjoie1wiZmlsZUlkc1wiOltdLFwicGFyYW1cIjp7fSxcImNhdGFsb2dJZHNcIjpbXCIxNDMwMzg4NDg3Mzk5NDI0MFwiXSxcInBvb2xJZHNcIjpbXCIxNDMwMzg4NDg3Mzk5NDI0MFwiXX0iLCJpc3MiOiJlY3AiLCJhdWQiOiJSdWppZS5GaWxlU2VydmljZSIsImV4cCI6MTU2MjAzOTQ0N30.HMxur5wUc3Dbgh6PzfigfCX45bJ7m4dGxG0pn9oI-bU" frameborder="0" width="100%" height="100%" name="frame" />
    </div>
  </div>
</template>
<script type="es6">
// import contractAgreement from './contractAgreement';
export default {
  data () {
    return {
      framesrc: '',
      btloading: false
    };
  },
  components: {
    // contractAgreement
  },
  props: {
    contractNum: {
      type: String,
      required: true
    }
  },
  computed: {},
  methods: {
    pageprint () {
      frames['frame'].print();
    }
  },
  mounted () {
    let eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
    let eventer = window[eventMethod];
    let messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
    eventer(messageEvent, (ev) => {
      if (ev.data.event_id === 'contractAgreementLoaded') {
        setTimeout(() => {
          this.btloading = false;
        }, 200);
      }
    });

    this.framesrc = window.location.origin + `/contractAgreementPrint/${this.contractNum}`;
  }
};
</script>
<style lang="scss" scoped>
  .printframe {
    width: 0;
    height: 0;
    border: none;
  }
  .print {
    position: absolute;
    top: 30px;
  }
</style>
